'use strict';

const TOGGLE_BTN_SELECTOR = '[data-toggle]';

function toggleEvent(event) {
    const element = event.target.closest(TOGGLE_BTN_SELECTOR);

    if (!element) {
        return;
    }

    if ('togglePreventDefault' in element.dataset) {
        event.preventDefault();
    }

    const toggleClass = element.dataset.toggleClass || 'is-toggled';
    const isToggled = element.classList.contains(toggleClass);

    const targetElements = document.querySelectorAll(element.dataset.toggle);
    targetElements.forEach(targetElement => {
        targetElement.classList.toggle(toggleClass);
        targetElement.setAttribute('aria-hidden', isToggled ? 'true' : 'false');
        targetElement.setAttribute('aria-expanded', isToggled ? 'false' : 'true');

    });

    const bodyClass = element.dataset.toggleBodyClass;
    const triggerResize = element.dataset.triggerResize;

    const toggleLabel = element.dataset.toggleLabel;
    const labelElements = document.querySelectorAll(
        element.dataset.toggleLabelSelector || '.js-toggle__label'
    );

    if (toggleLabel) {
        labelElements.forEach(labelElement => {
            element.dataset.toggleLabel = labelElement.innerHTML;
            labelElement.innerHTML = toggleLabel;
        });
    }

    const focusElements = document.querySelectorAll(element.dataset.toggleFocus);
    if (!isToggled && focusElements.length > 0) {
        focusElements[0].focus();
    }

    const closeElement = document.querySelector(element.dataset.toggleClose);
    if (closeElement && closeElement.classList.contains(toggleClass)) {
        closeElement.click();
    }

    element.classList.toggle(toggleClass);
    element.setAttribute('aria-expanded', isToggled ? 'false' : 'true');

    if (bodyClass) {
        document.body.classList.toggle(bodyClass);
    }
    if (triggerResize) {
        window.dispatchEvent(new Event('resize'));
    }
}

export default function () {
    document.addEventListener('click', toggleEvent, false);
}
